import { render, staticRenderFns } from "./OfficeLayout.vue?vue&type=template&id=2f988d66&"
import script from "./OfficeLayout.vue?vue&type=script&lang=js&"
export * from "./OfficeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports